import React, { useEffect, useRef, useState } from "react";
import {
    Chart,
    PieController,
    ArcElement,
    Tooltip,
    Legend,
} from "chart.js";
import { observer } from "mobx-react";
import Modal from "react-modal";
import Header from "../components/Header";
import About from "../components/About";
import Tokenomics from "../components/Tokenomics";
import { ethers } from "ethers";
import websiteStore from "../mobx/websiteStore";
import { toast, ToastContainer } from "react-toastify";
import Footer from "../components/Footer";
import Faq from "../components/Faq";
import Roadmap from "../components/Roadmap";
import Funding from "../components/Funding";
import FutureGoals from "../components/FutureGoals";
import ContractFeatures from "../components/ContractFeatures";
import ReferralSection from "../components/ReferralSection";
import CryptoJS from "crypto-js";
import QRCode from "react-qr-code";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toJS } from "mobx";

Chart.register(PieController, ArcElement, Tooltip, Legend);
Modal.setAppElement("#root");
const IndexPage = observer(() => {

    const [showModal, setShowModal] = useState(false);
    const [walletAddress, setWalletAddress] = useState("");
    const [amount, setAmount] = useState("");
    const [showModalRefer, setShowModalRefer] = useState(false);
    // const [timeLeft, setTimeLeft] = useState("00:00:00:00");
    // const [isProceedButtonDisabled, setIsProceedButtonDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [rewardData, setRewardData] = useState(null);
    const secretKey = process.env.APP_KEY || "AuthHandShake@SnowBallBoss"

    const [referralId, setReferralId] = useState("");
    const [userReferralId, setUserReferralId] = useState("");
    const [snowPurchase, setSnowPurchase] = useState("");
    const [displayValue, setDisplayValue] = useState(0); // Calculated value



    useEffect(() => {
        // Get the URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        // Get the referral code from the query string (referral=KAQB8F)
        const referral = urlParams.get('referral');
        setUserReferralId(referral);
    }, []);

    useEffect(() => {

        setDisplayValue(amount * 100);
    }, [amount]);


    const userSnowPurchase = snowPurchase?.data?.snowballAmount;

    console.log(userSnowPurchase, "userSnowPurchase");




    useEffect(() => {
        const checkReferralId = async () => {
            if (walletAddress) {
                const response = await websiteStore.getReferral(walletAddress);
                setReferralId(response.status ? response.data : "");
            }
        };
        checkReferralId();
    }, [walletAddress]);

    const handleReferralReward = async () => {
        console.log("anik");

        if (!walletAddress || !userReferralId) {
            toast.error("Wallet address or referral ID is missing.");
            return;
        }

        console.log(displayValue, "displayValue");



        setIsLoading(true); // Show loading state
        try {
            const param = {
                walletAddress: walletAddress,
                userReferralId: userReferralId,
                userSnowPurchase: displayValue,
            }
            console.log(param, "param");

            const rewardResponse = await websiteStore.getReferralReward(param);
            console.log(rewardResponse, "rewardResponse");

            setRewardData(rewardResponse);
            if (rewardResponse.status) {
                // Handle the successful reward response (e.g., show a success message, update state, etc.)
                toast.success("Referral reward fetched successfully!");
            } else {
                toast.error("Failed to fetch referral reward.");
            }
        } catch (error) {
            console.error("Error fetching referral reward:", error);
            toast.error("An error occurred while fetching referral reward.");
        } finally {
            setIsLoading(false); // Hide loading state
        }
    };

    const connectWallet = async (walletType) => {
        try {
            if (walletType === "metamask" || walletType === "trustwallet") {
                if (window.ethereum) {
                    const accounts = await window.ethereum.request({
                        method: "eth_requestAccounts",
                    });
                    setWalletAddress(accounts[0]);
                } else {
                    // If MetaMask extension is not found, try to open MetaMask app on mobile or desktop browser
                    toast.error("MetaMask not found! Redirecting to MetaMask App...");

                    // Deep link for MetaMask mobile or app browsers
                    const metamaskDeepLink = "https://metamask.app.link";
                    window.location.href = metamaskDeepLink; // Redirects to the MetaMask app or mobile browser
                }
            } else if (walletType === "phantom") {
                if (window.solana && window.solana.isPhantom) {
                    const response = await window.solana.connect();
                    setWalletAddress(response.publicKey.toString());
                } else {
                    toast.error("Phantom Wallet not found!");
                }
            }
        } catch (error) {
            console.error("Error connecting wallet:", error);
            toast.error("Failed to connect wallet."); // Added user-friendly error message
        }
        setShowModal(false);
    };



    const handleAmountChange = (e) => {
        setAmount(e.target.value);
    };

    const handleButtonClickMOdal = () => {
        if (!userReferralId) {
            setShowModalRefer(true);
        }
        else {
            sendUSDT();
        }

    };


    // const encrypt = (text, secretKey) => {
    //     const iv = crypto.randomBytes(16); // Generate random IV
    //     const cipher = crypto.createCipheriv('aes-256-cbc', secretKey, iv);
    //     let encrypted = cipher.update(text, 'utf8', 'hex');
    //     encrypted += cipher.final('hex');
    //     return iv.toString('hex') + ':' + encrypted; // Combine IV and encrypted text
    // };

    // Function to send USDT

    const encrypt = (text, secretKey) => {
        const iv = crypto.randomBytes(16); // Generate random IV
        const cipher = crypto.createCipheriv("aes-256-cbc", secretKey, iv);
        let encrypted = cipher.update(text, "utf8", "hex");
        encrypted += cipher.final("hex");
        return iv.toString("hex") + ":" + encrypted; // Combine IV and encrypted text
      };

    const sendUSDT = async () => {
        if (!window.ethereum) {
            toast.error("Please install MetaMask or connect to Ethereum!");
            return;
        }

        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();

        try {
            setIsLoading(true);

            // USDT Contract address (for Ethereum Mainnet)
            const usdtAddress = "0x4d5080D5f756413eD91811ff8958B5071F10b8D4";
            const usdtABI = [{ "inputs": [{ "internalType": "address", "name": "_teamWallet", "type": "address" }], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Burn", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "amountBurned", "type": "uint256" }], "name": "MilestoneBurn", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "teamWallet", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "Vesting", "type": "event" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }, { "internalType": "address", "name": "", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "burnAddress", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "burnOnMilestone", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "cliffPeriod", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "communityAirdropAllocation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "contractOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "developmentReserveAllocation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "lastVestingTime", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "liquidityPoolAllocation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "marketingPartnershipsAllocation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "milestoneBurnThreshold", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "mint", "outputs": [], "stateMutability": "pure", "type": "function" }, { "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "releaseTeamTokens", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "teamVestingPeriod", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "teamWallet", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalBurnableTokens", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalBurned", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalVestedTokens", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }];

            // Replace with the recipient's wallet address
            const recipientAddress = "0xeCb8305E476B91367B8c7Ae0C4a2988D82a441be";

            const amountInWei = ethers.utils.parseUnits(amount, 18);

            const contract = new ethers.Contract(usdtAddress, usdtABI, signer);

            // Send transaction with a manual gas limit
            const tx = await contract.transfer(recipientAddress, amountInWei, {
                gasLimit: ethers.utils.hexlify(100000), // Set gas limit
            });

            // Wait for transaction confirmation
            const receipt = await tx.wait();
            // alert("Transaction successful!", tx);

            
            if (receipt && receipt.status === 1) {
                const transactionHash = tx.hash;
                // const encryptedTxHash = encrypt(transactionHash, secretKey);
                const encryptedTxHash = encrypt(
                    transactionHash,
                    crypto.createHash("sha256").update("SnowBallBoss@Outrech@123").digest()
                  );
                const payload = {
                    transactionHash: encryptedTxHash, // Transaction hash
                    amountToSend: ethers.utils.formatUnits(amountInWei, 18), // Convert amount back to readable format
                    recipientAddress: await signer.getAddress(), // Sender's wallet address
                    location: "Bilaspur"
                };
                const response = await websiteStore.swapUsdt(payload);

                setSnowPurchase(response);

                // Handle the response
                if (response.status) {
                    toast.success(response?.message || "Transaction successful!");
                    if (!referralId) {
                        handleReferralReward();
                    }
                } else {
                    toast.error(response?.message || "API Error: Transaction failed.");
                }
            }
        } catch (error) {
            // console.error("Transaction failed:", error);
            toast.error("Transaction failed. Please try again.");
        } finally {
            setIsLoading(false);
            setAmount("");
            setWalletAddress("");
        }
    };

    const handleModalClose = (confirm) => {
        if (confirm) {
            // Proceed without referral ID
            alert("Proceeding without Referral ID");
        }
        setShowModalRefer(false); // Close modal
    };

    // useEffect(() => {
    //     websiteStore?.getTime();
    // }, []);

    // useEffect(() => {
    //     setTimeLeft(toJS(websiteStore?.data?.time));
    //     const timerId = setInterval(() => {
    //         websiteStore?.getTime();
    //     }, 1000);

    //     // Cleanup function to clear the interval
    //     return () => clearInterval(timerId);
    // }, [websiteStore?.data?.time]);

    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        const specificDate = new Date('2025-01-28T00:00:00Z');

        const updateTime = () => {
            const now = new Date();
            const timeDifference = specificDate - now;

            if (timeDifference <= 0) {
                setTimeLeft('Time’s up!');
                return;
            }

            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
        };

        updateTime(); // Initial call to set the time immediately
        const timerId = setInterval(updateTime, 1000); // Update every second

        // Cleanup interval on component unmount
        return () => clearInterval(timerId);
    }, []);

    // Handle button click
    const handleButtonClick = () => {
        setShowModalRefer(false);
        sendUSDT();

    };
    const isProceedButtonDisabled = !amount;

    console.log(referralId, "referralId");

    const handleNavigate = () => {
        const element = document.getElementById("buysnowball");
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }



    return (
        <>
            <Header />

            <About />

            <Tokenomics />

            <button className="floating-btn" onClick={handleNavigate}>
                Buy SnowBall
            </button>


            <div className="p-4">

                <img src="assets/img/snowball4.png" className="background-image" />
            </div>
            <img src="assets/img/left.png" className="header-img-coin1" />
            <img src="assets/img/right12.png" className="header-img-coin5" />


            <div className="presale-container">
                <video autoPlay muted loop className="background-video">
                    <source src="assets/img/background-video-snowball.mp4" type="video/mp4" />
                </video>
                <div className="presale-header" id="buysnowball">
                    <h1 className="weird-header">SNOWBALL PRESALE</h1>
                </div>
                <div className="coin-details">
                    <div className="coin-card">
                        <div className="reverse-clock time-item mb-3">{timeLeft}</div>
                        <p>introductory Price: $0.01</p>
                        <p>Total Supply: 1B</p>
                        <p>Presale Supply: 100M</p>
                    </div>
                </div>


                <div className="weird-inputs ">
                    <label><b>Your Referral Code</b></label>

                    <div className="referral-input-box">
                        <input
                            type="text"
                            value={userReferralId || ""}
                            readOnly // Read-only if there is a userReferralId
                            className="use-referral"
                            placeholder={
                                userReferralId?.length !== 6
                                    ? "Referral must be 6 characters"
                                    : "Enter Referral ID"
                            }
                            onChange={(e) => setUserReferralId(e.target.value)} // Assuming you want to update the referral ID
                        />
                    </div>

                </div>
                <div className="exchange-container1">
                    <div className="exchange-container weird-inputs">
                        <label><b>Pay with USDT (Bep20)</b></label>
                        <div className="exchange-section weird-input2">

                            <div className="currency-row">
                                <>
                                    {/*?xml version="1.0" encoding="UTF-8"?*/}
                                    <svg
                                        id="Layer_1"
                                        data-name="Layer 1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 409.24 409.24"
                                        width={40}
                                    >
                                        <defs>
                                            <style
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #58af9a;\n      }\n    "
                                                }}
                                            />
                                        </defs>
                                        <path
                                            className="cls-2"
                                            d="M409.24,204.62c0,113.01-91.61,204.62-204.62,204.62S0,317.63,0,204.62,91.61,0,204.62,0s204.62,91.61,204.62,204.62h0ZM409.24,204.62"
                                        />
                                        <path
                                            className="cls-1"
                                            d="M225.86,179.43v-24.16h54.98v-38.12h-152.58v38.12h55.12v24.16c-46.18,2.24-80.85,11.51-80.85,22.51s34.62,20.32,80.85,22.51v79.8h42.48v-79.8c46.18-2.21,80.85-11.48,80.85-22.51s-34.56-20.27-80.85-22.51h0ZM204.62,217.41c-50,0-90.55-7.74-90.55-17.04,0-8,29.53-14.74,69.26-16.54v27.3c6.83.3,13.94.49,21.24.49s14.45-.19,21.24-.49v-27.3c39.74,1.8,69.26,8.54,69.26,16.54.09,9.41-40.46,17.04-90.46,17.04h0ZM204.62,217.41"
                                        />
                                    </svg>
                                </>

                                <div className="currency-details">
                                    <p>USDT</p>
                                    <span>Bep20</span>
                                </div>

                                <input className="amount-input" type="number" placeholder="Min 10" min="10" value={amount}
                                    onChange={handleAmountChange} />


                            </div>
                        </div>
                        <label><b>You will get</b></label>
                        <div className="exchange-section weird-input2">
                            <div className="currency-row">

                                <img src="assets/img/front.png" className="header-coin" alt="USDT logo" />

                                <div className="currency-details">
                                    <p>Snowball</p>
                                    <span>SNOWBALL</span>
                                </div>

                                <input className="amount-input" type="number" placeholder="Snowballs..." min="101" value={displayValue}
                                    readOnly
                                    onChange={handleAmountChange} />

                            </div>

                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-center flex-column">
                    <div className="weird-inputs ">
                        {/* <label>Pay with USDT (Bep 20) </label>
                        <div className="w-100 row align-items-center">
                            <input
                                type="text"
                                className="weird-input1 "
                                id="amount-input"
                                placeholder="Enter Amount"
                                value={amount}
                                onChange={handleAmountChange}
                            />

                        </div>
                        <label>You Will get</label>
                        <div className="w-100 row align-items-center">
                            <input
                                type="text"
                                className="weird-input1"
                                id="amount-input"
                                placeholder="Snowballs..."
                                value={displayValue}
                                readOnly
                                onChange={handleAmountChange}
                            />
                            <div className="col-1">

                            </div>

                        </div> */}
                        <label>Wallet address</label>
                        <div className="w-100">
                            <input
                                type="text"
                                className="weird-input2 col-12"
                                placeholder="Wallet Address"
                                value={walletAddress}
                                disabled
                            />

                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center mt-3">
                    <button
                        className="pay-button"
                        id="proceed-to-pay-button"
                        onClick={walletAddress ? (handleButtonClickMOdal) : () => setShowModal(true)}
                        disabled={isLoading || isProceedButtonDisabled || amount < 10}
                    >
                        {walletAddress ? (isLoading ? "Processing..." : "Proceed to Pay") : "Connect Wallet"}
                    </button>
                </div>

            </div>

            <img src="assets/img/right12.png" className="header-img-coin2" />

            <Roadmap />



            {referralId && <section className="cosmic-referral-zone">
                <div className="galaxy-wrapper">
                    <h2 className="neon-title">🌌 Invite Your Friends to the Cosmic World! 🌌</h2>
                    <p className="wavy-text">
                        Share your unique referral link and let your friends join the fun. Earn stellar rewards for every signup!
                    </p>
                    <div className="referral-input-box">
                        <input
                            type="text"
                            className="galaxy-input"
                            value={`https://snowballboss.com/?referral=${referralId}`}
                            readOnly
                        />
                    </div>

                    <div style={{ height: "auto", margin: "0 auto", maxWidth: 120, width: "100%" }}>
                        <QRCode
                            size={400}
                            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                            value={`https://snowballboss.com/?referral=${referralId}`}
                            viewBox={`0 0 256 256`}
                        />
                    </div>

                    <div className="social-icons">
                        <a
                            href={`https://wa.me/?text=Join me on Snowball Boss and use my referral link: https://snowballboss.com/?referral=${referralId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-icon"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 0C5.372 0 0 5.372 0 12c0 2.124.55 4.123 1.512 5.873L0 24l6.275-1.457C8.064 23.48 10.001 24 12 24c6.628 0 12-5.372 12-12S18.628 0 12 0zm7.07 17.07a9.952 9.952 0 01-7.07 2.93 9.953 9.953 0 01-5.486-1.64l-.387-.233-3.651.846.86-3.578-.262-.413A9.953 9.953 0 012 12c0-5.523 4.477-10 10-10s10 4.477 10 10a9.952 9.952 0 01-2.93 7.07z"></path>
                                <path d="M17.122 14.804l-2.53-.72a1.254 1.254 0 00-1.164.216l-.506.38a7.44 7.44 0 01-3.594-3.594l.378-.506a1.253 1.253 0 00.217-1.164l-.72-2.529a1.25 1.25 0 00-1.195-.877h-1.5a1.25 1.25 0 00-1.25 1.25c0 5.102 4.148 9.25 9.25 9.25a1.25 1.25 0 001.25-1.25v-1.5c0-.526-.326-.99-.877-1.195z"></path>
                            </svg>
                        </a>
                        <a href={`https://www.instagram.com/direct/t/?text=Join me on Snowball Boss and use my referral link: https://snowballboss.com/?referral=${referralId}`} target="_blank" rel="noopener noreferrer" className="social-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 0c-3.037 0-3.408.012-4.603.067-1.188.056-2.005.24-2.71.512A5.422 5.422 0 003.09 1.525a5.422 5.422 0 00-1.225 1.596c-.272.705-.456 1.522-.512 2.71C1.012 7.025 1 7.396 1 10.433v3.134c0 3.037.012 3.408.067 4.603.056 1.188.24 2.005.512 2.71a5.422 5.422 0 001.225 1.596 5.422 5.422 0 001.596 1.225c.705.272 1.522.456 2.71.512 1.195.055 1.566.067 4.603.067 3.037 0 3.408-.012 4.603-.067 1.188-.056 2.005-.24 2.71-.512a5.422 5.422 0 001.596-1.225 5.422 5.422 0 001.225-1.596c.272-.705.456-1.522.512-2.71.055-1.195.067-1.544.067-4.603v-3.134c0-3.037-.012-3.408-.067-4.603-.056-1.188-.24-2.005-.512-2.71a5.422 5.422 0 00-1.225-1.596A5.422 5.422 0 0019.91.579c-.705-.272-1.522-.456-2.71-.512C15.408.012 15.037 0 12 0zm0 2.132c3.012 0 3.374.012 4.556.067 1.009.048 1.562.21 1.92.35.435.169.745.37 1.09.714.343.343.545.655.713 1.09.14.358.302.91.35 1.92.055 1.182.067 1.544.067 4.556 0 3.012-.012 3.374-.067 4.556-.048 1.009-.21 1.562-.35 1.92-.169.435-.37.745-.713 1.09-.343.343-.655.545-1.09.713-.358.14-.91.302-1.92.35-1.182.055-1.544.067-4.556.067-3.012 0-3.374-.012-4.556-.067-1.009-.048-1.562-.21-1.92-.35a3.43 3.43 0 01-1.09-.713 3.43 3.43 0 01-.713-1.09c-.14-.358-.302-.91-.35-1.92-.055-1.182-.067-1.544-.067-4.556 0-3.012.012-3.374.067-4.556.048-1.009.21-1.562.35-1.92.169-.435.37-.745.713-1.09a3.43 3.43 0 011.09-.713c.358-.14.91-.302 1.92-.35 1.182-.055 1.544-.067 4.556-.067zm0 4.131a5.737 5.737 0 00-5.737 5.737A5.737 5.737 0 0012 17.737a5.737 5.737 0 005.737-5.737A5.737 5.737 0 0012 6.263zm0 2.14a3.597 3.597 0 110 7.193 3.597 3.597 0 010-7.193zm5.637-4.014a1.256 1.256 0 110 2.514 1.256 1.256 0 010-2.514z"></path>
                            </svg>
                        </a>
                        <a href={`https://twitter.com/intent/tweet?text=Join me on Snowball Boss and use my referral link: https://snowballboss.com/?referral=${referralId}`} target="_blank" rel="noopener noreferrer" className="social-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M23.954 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723 10.18 10.18 0 01-3.127 1.194 4.928 4.928 0 00-8.391 4.49A13.978 13.978 0 011.671 3.149 4.822 4.822 0 003.195 9.7a4.902 4.902 0 01-2.23-.616c-.054 2.28 1.581 4.415 3.95 4.894-.693.187-1.452.232-2.224.084a4.935 4.935 0 004.604 3.419A9.896 9.896 0 010 21.543a13.932 13.932 0 007.548 2.211c9.057 0 14.002-7.496 14.002-13.986 0-.209 0-.423-.015-.637A10.07 10.07 0 0024 4.59l-.046-.02z"></path>
                            </svg>
                        </a>
                    </div>
                    <div className="orbit-animation">
                        <div className="orbit-circle orbit-one"></div>
                        <div className="orbit-circle orbit-two"></div>
                    </div>
                </div>
            </section>}

            <Funding />

            <ContractFeatures />

            <FutureGoals />



            <Faq />

            <Footer />

            <Modal
                isOpen={showModal}
                onRequestClose={() => setShowModal(false)} // Close modal when user clicks outside or close button
                contentLabel="Connect Wallet Modal"
                className="modal-content text-center"
                overlayClassName="modal-overlay"
            >
                <h2>Connect Wallet</h2>
                <button onClick={() => connectWallet("metamask")}>MetaMask</button>
                {/* <button onClick={() => connectWallet("trustwallet")}>Trust Wallet</button>
                <button onClick={() => connectWallet("phantom")}>Phantom Wallet</button> */}
                <button className="mx-auto w-50 bg-danger mt-3" onClick={() => setShowModal(false)}>Close</button>
            </Modal>
            <Modal
                isOpen={showModalRefer}
                onRequestClose={() => setShowModalRefer(false)}
                contentLabel="Warning..."
                className="modal-content text-center"
                overlayClassName="modal-overlay"
            >
                <p>Are you sure you want to continue without Using a Referral ID? </p>
                <button onClick={handleButtonClick}>Yes</button>
                <button onClick={() => handleModalClose(false)}>No</button>
            </Modal>

            <ToastContainer />

        </>
    )
})


export default IndexPage;
